import { STEPS } from '@pages/auth/registration/registration.types';
import styled, { css } from 'styled-components';

interface IHeaderSC {
  step?: number;
}

export const HeaderSC = styled.div<IHeaderSC>`
  position: relative;
  grid-area: header;
  align-self: flex-end;

  h1 {
    font-weight: 1000;
    font-size: ${(props) => (props.step === 0 || props.step === 4 ? '30px' : '25px')};
    margin: 0;
    color: ${({ theme }) => theme.color.tint.onCustom};
    text-shadow: ${({ theme }) => theme.shadows.medium};
  }

  svg {
    position: absolute;
    top: -30px;
    left: -70px;
  }

  @media (min-width: 900px) {
    max-width: 75%;
    h1 {
      font-size: 45px;
      line-height: 55px;
    }

    svg {
      width: 70px;
      height: 70px;
      left: -85px;
    }
  }

  @media only screen and (max-width: 899.99px) {
    h1 {
      text-align: center;
    }

    ${({ step }) =>
      step !== STEPS.LANDING
        ? css`
            .header-logo {
              display: none;
            }
          `
        : ''};
  }

  @media screen and (max-width: 500px) {
    .header-logo {
      display: none;
    }
  }
`;

export default HeaderSC;
